export const UNMOUNTING = "main/component_unmounting";

export const TAG_FILTER_UPDATE = "main/tag_filter_update";

export const TAGS_UPDATED_IN_SELECTION = "main/tags_updated_in_selection";

export const ENTRY_SELECTED = "main/entry_selected";
export const ENTRY_UNSELECTED = "main/entry_unselected";
export const ENTRIES_OPENED = "main/entries_opened";
export const GROUP_SELECTED = "main/group_selected";
export const GROUP_UNSELECTED = "main/group_unselected";

export const TOGGLE_SHOW_READ = "main/toggle_show_read";
export const TOGGLE_SORT_ORDER = "main/toggle_sort_order";

export const DONE_EDITING = "main/done_editing";
export const CANCEL_EDITING = "main/cancel_editing";
export const DONE_WITH_SELECTION = "main/done_editing_current_selection";

export const TOGGLE_ADD_MODAL = "main/toggle_add_modal";

export const SEARCH_TEXT_UPDATED = "main/search_text_updated";



// WEBPACK FOOTER //
// ./src/scenes/Main/actionTypes.js